import request from '@/utils/request'


// 查询用户信息列表
export function listUser(query) {
  return request({
    url: '/biz/user/list',
    method: 'get',
    params: query
  })
}

// 查询用户信息分页
export function pageUser(query) {
  return request({
    url: '/biz/user/page',
    method: 'get',
    params: query
  })
}
export function pageKf(query) {
  return request({
    url: '/biz/user/pageKf',
    method: 'get',
    params: query
  })
}
// 查询用户信息详细
export function getUser(data) {
  return request({
    url: '/biz/user/detail',
    method: 'get',
    params: data
  })
}

export function authentication(data) {
  return request({
    url: '/biz/user/authentication',
    method: 'post',
    params: data
  })
}

// 新增用户信息
export function addUser(data) {
  return request({
    url: '/biz/user/add',
    method: 'post',
    data: data
  })
}

// 修改用户信息
export function updateUser(data) {
  return request({
    url: '/biz/user/edit',
    method: 'post',
    data: data
  })
}

// 删除用户信息
export function delUser(data) {
  return request({
    url: '/biz/user/delete',
    method: 'post',
    data: data
  })
}
// 是否是客服
export function updateRole(data) {
  return request({
    url: '/biz/user/updateRole',
    method: 'post',
    data: data
  })
}
// 是否是商户
export function updateMerchant(data) {
  return request({
    url: '/biz/user/updateMerchant',
    method: 'post',
    data: data
  })
}


export function updSysUserByService(data) {
  return request({
    url: '/biz/user/updSysUserByService',
    method: 'post',
    data: data
  })
}